import { Roles } from "../../../../auth/roles.enum";


export class MenuItem {
    primaryText: string;
    routerLink: string;
    icon: string;
    primaryColor?: string;
    secondaryText?: string;
    secondaryColor?: string;
    isNavigable? = true;
    children?: MenuItem[];

    /** Roles that can access this menu item */
    roles?: Roles[];

    /** Roles that cannot access this menu item */
    excludeRoles?: Roles[]
    queue?: string;
    isExpanded? = false;
}


// WEBPACK FOOTER //
// ./src/app/core/components/menu/side-nav/menu-item.ts